import React, {
  FunctionComponent,
  MouseEvent,
  DetailedHTMLProps,
  ButtonHTMLAttributes,
} from 'react';
import withStyles from 'react-jss';
import classnames from 'classnames';
import { Loader } from 'semantic-ui-react';

import { Theme } from 'config';
import { ClassProp } from 'helpers/types';

type Props = {
  classes: ClassProp<ReturnType<typeof buttonStyles>>;
  title?: string;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  fluid?: boolean;
  type?: DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > &
    any;
  onClick?: ((
    event: MouseEvent<
      HTMLDivElement,
      MouseEvent<Element, MouseEvent<Element, MouseEvent>>
    >,
  ) => void) &
    any;
  value?: string | number;
};

export const buttonStyles = (theme: Theme) => ({
  button: {
    border: 'none',
    backgroundColor: theme.violet,
    borderRadius: '1.5rem',
    color: '#fff !important',
    fontSize: '.8rem',
    marginTop: '1rem',
    opacity: 1,
    padding: '0.5rem 1.25rem',
    fontWeight: '500',
    lineHeight: '1.25rem',
    cursor: 'pointer',
    textAlign: 'center',

    '&:focus': {
      outline: 0,
    },
    '&:first-child': {
      marginLeft: '1rem`',
    },
    '&:hover': {
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
    '.selected': {
      opacity: 0.7,
    },
    '&.fluid': {
      flex: 1,
    },
    '&:disabled': {
      backgroundColor: theme.disabledBtnGray,
      color: '#f7f8f9 !important',
      pointerEvents: 'none !important',
      opacity: 0.6,
    },
  },
});

const Button: FunctionComponent<Props> = ({
  classes,
  className,
  title,
  children,
  onClick,
  type = 'button',
  disabled = false,
  loading = false,
  value = '',
  fluid = false,
}) => (
  <button
    disabled={disabled}
    type={type}
    onClick={onClick}
    className={classnames(classes.button, className, {
      fluid,
    })}
    value={value}
  >
    {loading ? (
      <Loader active inline="centered" size="small" />
    ) : (
      title || children
    )}
  </button>
);

export default withStyles(buttonStyles)(Button);
